import type { Role } from '../api/schemas';

export function isOwner(role: Role | undefined): boolean {
  return role === 'owner';
}

export const ROLE_LABEL: Record<Role, string> = {
  owner: 'Dueño',
  employee: 'Empleado',
};

/**
 * A coach is an employee whose login works as one roster entry. The API already
 * narrows their bookings and classes; the portal gives them a matching shell.
 */
export function isCoach(session: { role: Role; staffMemberId?: string | null } | null | undefined): boolean {
  return session?.role === 'employee' && Boolean(session.staffMemberId);
}
